jQuery(document).ready(function($) {
			var updateTimer;

			// Plus/Minus button functionality
			$(document).on('click', '.cart-qty-btn', function(e) {
				e.preventDefault();

				var $button = $(this);
				var $wrapper = $button.closest('.cart-quantity-wrapper');
				var $input = $wrapper.find('.cart-qty-input');
				var action = $button.data('action');
				var currentVal = parseFloat($input.val()) || 1;
				var min = parseFloat($input.attr('min')) || 1;
				var max = parseFloat($input.attr('max')) || 999;
				var step = parseFloat($input.attr('step')) || 1;
				var newVal = currentVal;

				if (action === 'increase') {
					newVal = Math.min(max, currentVal + step);
				} else if (action === 'decrease') {
					newVal = Math.max(min, currentVal - step);
				}

				if (newVal !== currentVal) {
					$input.val(newVal).trigger('change');
				}
			});

			// Auto-update cart when quantity changes
			$(document).on('change', '.cart-qty-input', function() {
				var $input = $(this);

				clearTimeout(updateTimer);

				updateTimer = setTimeout(function() {
					$('[name="update_cart"]').prop('disabled', false).trigger('click');
				}, 800);
			});

			// Prevent form submission on Enter key
			$(document).on('keypress', '.cart-qty-input', function(e) {
				if (e.which === 13) {
					e.preventDefault();
					$(this).trigger('change');
				}
			});
		});
